// Service "embellissement" : appel backend uniquement (les écrans n'appellent jamais le LLM en direct).
const API = process.env.REACT_APP_BACKEND_URL;

export async function generatePolish(text) {
  const res = await fetch(`${API}/api/polish`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ text }),
  });
  if (!res.ok) throw new Error("polish failed");
  const data = await res.json();
  return (data.polished || "").trim();
}
